import React from 'react';
import UnListPropertyComponents from '../../Properties/unListProperty';

export default function UnListProperty() {
  return <UnListPropertyComponents />;
}
